import { Route, Routes } from "react-router";
import { useUser } from "./context/user.context";

import SignIn from "./pages/SignIn";
import TimeTable from "./pages/Table";
import TableList from "./pages/TableList";

// ======================================================= //

function App() {

    const {user} = useUser();

    // ------------------------------------------------------- //

    return (
        <Routes>
            {
                // if user is not signed in, route to signin page
                user.id === null && 
                <Route index element={<SignIn/>}/> 
            }

            {
                // if user is signed in, show them their tables
                user.id !== null && 
                <Route index element={<TableList/>}/> 
            }

            <Route exact path='/table/:id' element={<TimeTable />} />
        </Routes>
    );
}

export default App;

// ======================================================= //